<div class="modal-header">
  <h4 class="modal-title">Edit Delegate</h4>
</div>
<div class="modal-body">
  <section>
    @if (errorMsg !== '') {
      <p id="error-msg">Error:&nbsp;{{errorMsg}}</p>
    }
  </section>
  <form [formGroup]="delegateForm">
    <div>
      <section class="modal-section1">
        <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
          <label for="name" class="Fields-label icon-label">Name (Email ID)</label>
          <input type="text" placeholder="Enter Location" [matAutocomplete]="auto" class="Fields-input form-control"
            formControlName="delegateName" (input)="searchApprovers()">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateMySelection($event)">
            @for (approver of searchApproversList; track approver) {
              <mat-option [OptionValue]="approver"
                [value]="approver.nameEmail">
                {{approver.nameEmail}}
              </mat-option>
            }
          </mat-autocomplete>
          @if (f.delegateName.touched && f.delegateName.errors) {
            <section class="invalid-error">
              @if (f.delegateName.errors.required) {
                <section>
                  Please select a customer
                </section>
              }
            </section>
          }
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
          <label for="phoneNumber" class="Fields-label icon-label">Phone Number</label>
          <input id="phoneNumber" name="phoneNumber" type="tel" [appMobMask]="'phone'" class="Fields-input"
            placeholder="xxx-xxx-xxxx" formControlName="delegatePhoneNumber" maxlength="12">
          @if (f.delegatePhoneNumber.touched && f.delegatePhoneNumber.errors) {
            <section class="invalid-error">
              @if (f.delegatePhoneNumber.errors.pattern) {
                <section>
                  Please enter a valid phone number
                </section>
              }
            </section>
          }
        </div>
      </section>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div class="change-request-btngrps">
    <button type="submit" class="btn-primary" data-di-id="#addApprover" (click)="updateDelegate()"
      [disabled]="!submitted ? !delegateForm.valid: 'true'">
      Save delegate
    </button>
    <button type="button" class="btn-secondary" data-dismiss="modal" (click)="cancelPopup()">
      Cancel
    </button>
  </div>
</div>